import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-anchor",
  templateUrl: "./med-icon-anchor.component.html",
})
export class MedIconAnchorComponent extends SvgMixinComponent {}
